<template>
	<div data-component="highlighted-text" :class="size">
		<SanityContent v-if="text" :blocks="text" :serializers="serializers" />
	</div>
</template>

<script setup>
import StrongText from './StrongText.vue'

const props = defineProps({
	text: { type: Array, default: undefined },
	size: { type: String, default: '' },
})

provide('highlightedTextSize', props.size)

const serializers = {
	marks: {
		strong: StrongText,
	},
}

const setup = () => {}
const init = () => {}
const kill = () => {}

onBeforeUnmount(() => {})
onMounted(() => {})
</script>

<style lang="scss" scoped>
[data-component='highlighted-text'] {
	position: relative;

	text-align: center;

	width: 100%;

	@include title-1;

	&.small {
		@include title-3;
	}
}
</style>
